import type { AxiosInterceptorManager, AxiosResponse, CreateAxiosDefaults } from "axios";
import axios from "axios";

import { NAMES as HEADER_NAMES } from "./header";

type Config = Pick<CreateAxiosDefaults, "validateStatus"> & {
  baseUrl: NonNullable<CreateAxiosDefaults["baseURL"]>;
  interceptors?:
    | {
        response: {
          onFulfilled?: Parameters<AxiosInterceptorManager<AxiosResponse>["use"]>[0] | undefined;
          onRejected?: Parameters<AxiosInterceptorManager<AxiosResponse>["use"]>[1] | undefined;
        }[];
      }
    | undefined;
  getLocale: () => string;
};

function createAxios({ baseUrl, interceptors, getLocale, ...config }: Config) {
  const instance = axios.create({
    baseURL: baseUrl,
    withCredentials: true,
    ...config,
  });

  instance.interceptors.request.use((config) => {
    if (!config.headers.has(HEADER_NAMES.acceptLanguage)) {
      config.headers[HEADER_NAMES.acceptLanguage] = getLocale();
    }

    return config;
  });

  for (const { onFulfilled, onRejected } of interceptors?.response ?? []) {
    instance.interceptors.response.use(onFulfilled, onRejected);
  }

  return instance;
}

export { createAxios };
